import type { ExtensionConfig } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'
import { UnleashFlags } from '../models/feature-flag.models'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { createMsTeamsIntegrationConfigIfFlagEnabled } from '../helpers/ms-teams-integration-helpers'

const integrationFlagSuffix = 'oos-meeting-background-service'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-meeting-background-service',
  get url() {
    const version = getFeatureFlag(UnleashFlags.OOS_MEETING_BG_SERVICE_VERSION, 'release')
    return new URL(getOOSArtifactUrl('meeting-background-service-extension', version))
  },
  integrations: {
    get msTeams() {
      return createMsTeamsIntegrationConfigIfFlagEnabled(integrationFlagSuffix)
    },
  }

}

export default extensionConfig
